import { HttpParams } from '@angular/common/http';
import { PageEvent } from './PageEvent';

export class ParamsBuilder {

  private _params: HttpParams;

  constructor() {
    this._params = new HttpParams();
  }

  set params(params: any) {
    Object.keys(params).forEach(key => {
      this._params = this._params.append(key, params[key]);
    });
  }

  set pageEvent(pageEvent: PageEvent) {
    pageEvent = pageEvent ? pageEvent : new PageEvent();

    this._params = this._params.append('page', pageEvent.page.toString());
    this._params = this._params.append('limit', pageEvent.limit.toString());
  }

  set page(val: number) {
    this._params = this._params.append('page', val.toString());
  }

  set limit(val: number) {
    this._params = this._params.append('limit', val.toString());
  }

  set selectFields(val: string | string[]) {
    const param = val instanceof Array ? this.convertToString(val) : val;
    this._params = this._params.append('select', param);
  }

  set sort(val: string | string[]) {
    const param = val instanceof Array ? this.convertToString(val) : val;
    this._params = this._params.append('sort', param);
  }

  set populate(val: string | string[]) {
    const param = val instanceof Array ? this.convertToString(val) : val;
    this._params = this._params.append('populate', param);
  }

  set q(val: any) {
    if (!val) {
      return;
    }

    this._params = this._params.append('q', val);
  }

  set query(val: any) {
    if (!val) {
      return;
    }

    const query = JSON.stringify(val);
    this._params = this._params.append('query', query);
  }

  build(): HttpParams {
    return this._params;
  }

  setParam(key: string, val: any) {
    if (!val) {
      return;
    }
    this._params = this._params.append(key, val);
  }

  private convertToString(arr: string[]) {
    return arr.join().replace(/,/g, ' ');
  }
}
